/* src/app/reports/sales-report/report-generator-result/sale-report-generator-result.component.css */
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
tr:nth-child(even) {
  background-color: #dddddd;
}
.report-header {
  background: var(--custom-color);
  color: white;
}
/*# sourceMappingURL=sale-report-generator-result.component.css.map */
